import React, {useContext, useMemo, useRef, useState} from 'react';
import {defaultCSSearchParam, stateList} from "../../../shared/utils/defaultData";
import dayjs from "dayjs";
import {buildUrl} from "../../../shared/utils/net";
import {Tag} from "antd";
import CsEditModal from "../../cs/CsEditModal";
import TablePage from "../../../pages/tablePage/TablePage";
import {PlayerContext} from "../../../shared/contexts/playerContext";

const initSearchParam = (player) => {
    const searchParams = {...defaultCSSearchParam};
    searchParams.begin = dayjs().subtract(7, 'day').startOf('day').unix();
    searchParams.end = dayjs().endOf('day').unix();
    searchParams.userKey = player.userKey;
    return searchParams;
}

const PlayerCsLog = () => {
    const { playerData } = useContext(PlayerContext);
    const [searchParam] = useState(initSearchParam(playerData));
    const [url] = useState(buildUrl('cs', searchParam));
    const [rowData, setRowData] = useState({});

    const refreshRef = useRef(null);

    const columns = useMemo(() => ([
        {
            title: '접수일',
            dataIndex: 'requested',
            render: (requested) => dayjs.unix(requested).format('YYYY-MM-DD HH:mm'),
            width: 170,
            sorter: (a, b) => a.requested - b.requested,
        },
        {
            title: '답변일',
            dataIndex: 'replied',
            render: (replied) => replied === 0 ? '' : dayjs.unix(replied).format('YYYY-MM-DD HH:mm'),
            width: 170,
            sorter: (a, b) => a.replied - b.replied,
        },
        {
            title: '디바이스',
            dataIndex: 'device',
        },
        {
            title: 'OS',
            dataIndex: 'os',
        },
        {
            title: 'E-Mail',
            dataIndex: 'email',
        },
        {
            title: '문의 유형',
            dataIndex: 'type',
            width: 150,
            render: (_, {type}) => {
                let color, text;
                switch (type) {
                    case 0:
                        color = 'cyan';
                        text = '계정';
                        break;
                    case 1:
                        color = 'green';
                        text = '버그';
                        break;
                    case 2:
                        color = 'blue';
                        text = '결제';
                        break;
                    case 3:
                        color = 'purple';
                        text = '기타';
                        break;
                    default:
                        color = 'lightgray';
                        text = 'Unknown';
                }
                return <Tag color={color}>{text}</Tag>;
            },
            filters: [
                {text: '계정', value: 0},
                {text: '버그', value: 1},
                {text: '결제', value: 2},
                {text: '기타', value: 3},
            ],
        },
        {
            title: '상태',
            dataIndex: 'state',
            width: 150,
            render: (_, {state}) => (
                <Tag color={stateList[state].color}>
                    {stateList[state].text}
                </Tag>
            ),
            filters: stateList,
            onFilter: (value, record) => record.state === value,
        },
        {
            title: '국가',
            dataIndex: 'region',
            width: 80
        },
    ]), []);

    const props = {
        columns,
        rowData,
        setRowData,
        refreshRef,
        url,
        modal: CsEditModal,
    }

    return (
        <TablePage {...props}/>
    );
};

export default PlayerCsLog;